import React, { useEffect, useState } from 'react';
import '../styles/Login.css';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSession } from '../contexts/SessionContext';

interface ErrorPageProps {
  error?: string;
  errorMessage?: string;
}

const ErrorPage: React.FC<ErrorPageProps> = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [countdown, setCountdown] = useState(5); // Countdown for 5 seconds
  const { redirectUri } = useSession();
  // Extract state from location
  const { errorMessage, error } = location.state || {};

  useEffect(() => {
    if (redirectUri) {
      // Use the URL constructor to safely append query parameters
      const url = new URL(redirectUri);
      url.searchParams.set('error', error || 'internal_error');
      url.searchParams.set('error_description', errorMessage || 'An unexpected error occurred');

      // Start a countdown timer for the redirect
      const interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);

      // Redirect after 5 seconds
      const timer = setTimeout(() => {
        window.location.href = url.toString();
      }, 5000);

      // Cleanup timers when the component unmounts
      return () => {
        clearTimeout(timer);
        clearInterval(interval);
      };
    }
  }, [redirectUri, error, errorMessage]);

  return (
    <div className="login-container">
      <div className="logo"></div>
      <div className="login-box">
        <div className="mt error-img"></div> 
        <h2>{t('ui_error_something_wrong')}</h2>
        <p>{errorMessage || t('error_unexpected')}</p>
        {redirectUri ? (
          <p>{t('ui_redirecting')} {countdown} {t('ui_seconds')}...</p>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default ErrorPage;
